// extracted by mini-css-extract-plugin
export default {"checkboxRoot":"FieldCheckbox_checkboxRoot__nGCcD","checkboxIndicator":"FieldCheckbox_checkboxIndicator__GiS3a","checkboxLabel":"FieldCheckbox_checkboxLabel__y84aq"};